import keycloakAxios from '@/services/axios';

export const fetchModules = async () => {
  const response = await keycloakAxios.get('admin/healthmodule');

  if (response.status === 300) {
    throw new Error(
      `Error fetching modules: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
